module.exports = __webpack_public_path__ + "img/gb_right@2x.15b0b7e8.png";